import { createTheme, ThemeOptions } from '@mui/material';

const themeOptions: ThemeOptions = {
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: '#FFFFFF',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#086A33', // Deep Green
      light: '#4CAF50', // Lighter green
      contrastText: '#FFFFFF', // White text
      dark: '#6E7783',
    },
    secondary: {
      main: '#FBB13C', // Golden Yellow
      light: '#fcf0deff',
      contrastText: '#000000', // Black text
      dark: '#D97706',
    },
    background: {
      default: '#F4F1EA', // Warm Beige
      paper: '#FFFFFF', // White
    },
    text: {
      primary: '#212121', // Darker gray
      secondary: '#757575', // Medium gray
      disabled: '#BDBDBD',
    },
    info: {
      main: '#1976D2', // Deeper blue
      light: '#42A5F5',
      dark: '#0D47A1',
      contrastText: '#FFFFFF',
    },
    common: {
      white: '#EEEEEE',
      black: '#000000',
    },
  },
  typography: {
    fontFamily: '"DM Sans", "Roboto", "Arial", sans-serif',
    fontSize: 14,
    h1: { fontSize: '2.5rem', fontWeight: 600 },
    h2: { fontSize: '2rem', fontWeight: 500 },
    h3: { fontSize: '1.75rem', fontWeight: 500 },
    h4: { fontSize: '1.5rem', fontWeight: 500 },
    h5: { fontSize: '1.2rem', fontWeight: 500 },
    body1: { fontSize: '1rem' },
    body2: { fontSize: '0.875rem' },
    button: { fontWeight: 600, textTransform: 'none' },
  },
};

export const theme = createTheme({ ...themeOptions });
